import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OrderService } from '../order/order.service';
import { Order } from '../order/order.model';
import { User } from '../auth/user.model';
import { Subscription } from 'rxjs/index';
import { UIService } from '../shared/ui.service';
import { AuthService } from '../auth/auth.service';
import { MatSort, MatTableDataSource } from '@angular/material';
import { StorageService } from '../storage/storage.service';
import { Permission } from '../access/access.service';

@Component({
  selector: 'app-invoice-v2',
  templateUrl: './invoice-v2.component.html',
  styleUrls: ['./invoice-v2.component.css']
})



export class InvoiceV2Component implements OnInit, OnDestroy, AfterViewInit {
  user: User;
  orders: Order[];
  isLoading = false;

  displayedColumns: string[] = ['id', 'deliveryDate', 'address', 'amount', 'credit', 'paid', 'detail'];
  dataSource = new MatTableDataSource();

  currentLanguage = 'en';

  @ViewChild(MatSort) sort: MatSort;

  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;
  currentProject: number;
  hasAccessToData: boolean;

  constructor(
    private orderService: OrderService,
    private uiService: UIService,
    private authentication: AuthService,
    private _ref: ChangeDetectorRef,
    private localStorage: StorageService

  ) { }

  ngOnInit() {

    this.currentLanguage = this.localStorage.getPreferredLanguage();

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
      this._ref.markForCheck();
    });

    this.user = this.authentication.getUser();

    this.getOrdersWithV2Invoices();
    this.hasAccessToData = this.validateAccessToData();

    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
      this.currentProject = projectId
      this.getOrdersWithV2Invoices();
      this.hasAccessToData = this.validateAccessToData();
    });

  }

  validateAccessToData() {
    return this.authentication.hasAccessToProject(this.currentProject, Permission.ADMIN);
  }


  getOrdersWithV2Invoices() {
    this.orderService.getOrdersWithV2Invoices(this.user.token).subscribe((res: Order[]) => {
        this.orders = res;
        this.uiService.loadingStateChanged.next(false);
        this.dataSource = new MatTableDataSource(this.orders);
    },(error: Error) => {
        if(error ){
          this.orders = [];
      }});
  }


  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }

}
